import { createSelector } from 'reselect';

import { StateDictionary } from './utils/state-manager';

type SurveysByIdDictionary = { [surveyId: number]: Survey };
type SurveyResponseByIdDictionary = { [surveyResponseId: number]: SurveyResponse };

export type SurveyState = {
  surveysById: SurveysByIdDictionary;
  surveysStateByOrgId: StateDictionary;
  surveyResponsesById: SurveyResponseByIdDictionary;
  surveyResponsesStateBySurveyId: StateDictionary;
  surveyResponsesStateBySurveyResponseId: StateDictionary;
};
type State = { surveys: SurveyState };

const surveysByIdSelector = (state: State) => state.surveys.surveysById;
const surveysStateByOrgIdStateSelector = (state: State) => state.surveys.surveysStateByOrgId;
export const surveysForOrgIdSelector = createSelector(
  [surveysByIdSelector, (_state: State, orgId: number) => orgId],
  (surveysById, orgId) => Object.values(surveysById).filter((survey) => survey.orgId === orgId),
);
export const surveyForIdSelector = createSelector(
  [surveysByIdSelector, (_state: State, surveyId: number) => surveyId],
  (surveysById, surveyId) => surveysById[surveyId],
);
export const surveysForOrgIdStateSelector = createSelector(
  [surveysStateByOrgIdStateSelector, (_state: State, orgId: number) => orgId],
  (surveysStateByOrgId, orgId) => surveysStateByOrgId[orgId],
);

const surveyResponsesByIdSelector = (state: State) => state.surveys.surveyResponsesById;
const surveyResponsesBySurveyIdStateSelector = (state: State) =>
  state.surveys.surveyResponsesStateBySurveyId;
const surveyResponsesBySurveyResponseIdStateSelector = (state: State) =>
  state.surveys.surveyResponsesStateBySurveyResponseId;
export const surveyResponsesForSurveyIdSelector = createSelector(
  [surveyResponsesByIdSelector, (_state: State, surveyId: number) => surveyId],
  (surveyResponsesById, surveyId) =>
    Object.values(surveyResponsesById).filter((response) => response.surveyId === surveyId),
);
export const surveyResponsesStateForSurveyIdSelector = createSelector(
  [surveyResponsesBySurveyIdStateSelector, (_state: State, surveyId: number) => surveyId],
  (surveyResponsesBySurveyIdState, surveyId) => surveyResponsesBySurveyIdState[surveyId],
);
export const surveyResponsesStateForSurveyResponseIdSelector = createSelector(
  [
    surveyResponsesBySurveyResponseIdStateSelector,
    (_state: State, surveyResponseId: number) => surveyResponseId,
  ],
  (surveyResponsesBySurveyResponseIdState, surveyResponseId) =>
    surveyResponsesBySurveyResponseIdState[surveyResponseId],
);
